import React from 'react';
import ExperiencesNavigation from '../../ExperiencesNavigation';
import {Recommendations} from '../../Recommendations';
import {StyledCaseRecommendations, Row, Col, RecommendationsOff25} from './styled';

function CaseRecommendations() {
  return (
    <StyledCaseRecommendations>
      <Row style={{justifyContent: 'center'}}>
        <RecommendationsOff25>UP TO 25% OFF</RecommendationsOff25>
      </Row>
      <Col style={{justifyContent: 'center'}}>
        <div className="recomendationsTitle">You may be interested in</div>
        <div className="recomendationsSubTitle">Control your experience</div>
      </Col>
      <Row>
        <ExperiencesNavigation />
      </Row>
      <Row>
        <Recommendations reservationId="1" />
      </Row>
    </StyledCaseRecommendations>
  );
}

export default CaseRecommendations;
